import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../../app/routes';
import { usePageMeta } from '../../core/usePageMeta';
import { HubSearchBar, PublicLayout } from './components';

/**
 * Unknown address. It used to redirect to `/`, which made every mistyped URL a duplicate of the
 * home page ("soft 404"); now it says so and is `noindex`.
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  usePageMeta(t('hub.seo.notFound.title', 'Page not found'), { noindex: true });
  return <PublicLayout showHeaderSearch={false}>
    <section className="hub-hero"><div className="hub-wrap">
      <h1>{t('hub.seo.notFound.title', 'Page not found')}</h1>
      <p>{t('hub.seo.notFound.text', 'The address you asked for does not exist or has moved.')}</p>
      <HubSearchBar />
      <div className="hub-hero-meta">
        <Link className="hub-btn" to={ROUTES.landing}>{t('hub.seo.notFound.home', 'Back to the home page')}</Link>
        <Link className="hub-btn ghost" to={ROUTES.exploreBusinesses}>{t('hub.nav.businesses', 'Businesses')}</Link>
        <Link className="hub-btn ghost" to={ROUTES.exploreJobs}>{t('hub.nav.jobs', 'Jobs')}</Link>
      </div>
    </div></section>
  </PublicLayout>;
}
